exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xm-order-detail .title-sub{margin-left:.8em;font-size:12px;font-style:normal;color:#909090}@media (max-width:700px){.xm-order-detail{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.xm-order-detail .title-sub{display:block;margin-top:.5em;margin-left:0}}.download-link{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:1em}", ""]);

// exports
